module.exports = __webpack_public_path__ + "img/65708.b8bc780b.png";